import { Box, Text, Stack } from '@machobear/design-system'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import TriggerCard from './TriggerCard'
import { GroupAutoReply } from '../helpers/utils'

type MessagesListProps = {
  title: keyof typeof GroupAutoReply
  onClick?: () => void
  data: { txt_id: string; name: string; description: string }[]
}

export type TriggerListData = { txt_id: string; name: string; description: string }

const TriggerList = ({ title, data }: MessagesListProps) => {
  const { t } = useTranslation()
  const history = useHistory()

  const clickButton = (id: string) => {
    history.push(`/settings/auto-reply/manage?trigger=${id}`)
  }

  return (
    <>
      <Box marginTop={'small'}>
        <Text tone="secondary" size="medium">
          {title as keyof typeof GroupAutoReply}
        </Text>
      </Box>
      <Box aria-label={title as keyof typeof GroupAutoReply}>
        <Stack space={'medium'}>
          {data?.map((item: TriggerListData) => (
            <TriggerCard
              id={item.txt_id}
              title={t(`l.settings.auto_reply.${item.txt_id}.title`, item.name)}
              description={t(`l.settings.auto_reply.${item.txt_id}.description`, item.description)}
              onClick={() => clickButton(item.txt_id)}
              key={item.txt_id}
            />
          ))}
        </Stack>
      </Box>
    </>
  )
}

export default TriggerList
